import { extendTheme, withDefaultColorScheme } from "@chakra-ui/react";

export const theme = extendTheme(withDefaultColorScheme({ colorScheme: "bij12_1" }), {
  styles: {
    global: {
      a: {
        color: "bij12_2.700",
      },
    },
  },
  fonts: {
    // Defined in ./fonts.tsx
    body: `'Body Font Name', 'sans-serif'`,
    heading: `'Heading Font Name', 'serif'`,
  },
  fontWeights: {
    normal: 700,
    medium: 500,
    bold: 700,
    semibold: 800,
  },
  colors: {
    bij12_1: {
      // First 8 picked from style guide, 800 and 900 invented
      // as darker versions of standard (700).
      50: "#faefed",
      100: "#f0cfca",
      200: "#e5afa6",
      300: "#e0a094",
      400: "#db9082",
      500: "#d68071",
      600: "#d1705f",
      700: "#cc604d",
      800: "#a05846",
      900: "#864e3e",
    },
    bij12_2: {
      50: "#e5eff6",
      100: "#ccdfed",
      200: "#b2cfe4",
      300: "#80aed2",
      400: "#669ec9",
      500: "#337eb7",
      600: "#196eae",
      700: "#005ea5",
      800: "#00509c",
      900: "#004493",
    },
  },
});
